import originalSchema from "../../../gen/schema/witbooking.backoffice.establishment.v1/Property.json";

export const schema = {
  ...originalSchema,
  required: [
    ...originalSchema.required,
    ...originalSchema.properties.location.required,
    "latitude",
    "longitude",
  ],
  properties: {
    ...originalSchema.properties,
    ...originalSchema.properties.location.properties,
    searchCoordinates: {
      properties: {
        value: {
          type: "string",
        },
        label: {
          type: "string",
        },
      },
      type: "object",
    },
    latitude: {
      type: "number",
      minimum: -90,
      maximum: 90,
    },
    longitude: {
      type: "number",
      minimum: -180,
      maximum: 180,
    },
    location: undefined,
    amenities: undefined,
    locationSection: {
      type: "string",
    },
    contactSection: {
      type: "string",
    },
    propertyType: {
      enum: [
        "HOTEL",
        1,
        "APART_HOTEL",
        2,
        "APARTMENT",
        3,
        "HOSTEL",
        4,
        "HOUSES",
        5,
        "HOTEL_WITH_SPA",
        6,
        "RURAL",
        7,
        "WATERING_PLACE",
        8,
        "WELLNESS",
        9,
        "PARKING",
        10,
        "EXCURSIONS",
        11,
      ],
      oneOf: [
        {
          type: "string",
        },
        {
          type: "integer",
        },
      ],
    },
    valuation: {
      enum: ["*", 1, "**", 2, "***", 3, "****", 4, "*****", 5],
      oneOf: [
        {
          type: "string",
        },
        {
          type: "integer",
        },
      ],
    },
    multimedia: {
      ...originalSchema.properties.multimedia,
      items: {
        ...originalSchema.properties.multimedia.items,
        additionalProperties: true,
      },
    },
    amenitiesSection: {
      type: "string",
    },
    amenitiesList: {
      type: "object",
      additionalProperties: {
        type: "object",
        properties: {
          value: { type: "string" },
          icon: { type: "string" },
          translations: {
            type: "array",
            items: {
              type: "object",
              properties: {
                locale: { type: "string" },
                name: { type: "string" },
              },
            },
          },
        },
      },
    },
  },
};
